export default __webpack_public_path__ + "static/media/sales-force-logo.0e88e861.svg";